var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalShifts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50.1953,
    height: 50.1953,
    rx: 6,
    fill: "#E6ECF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9993 17.1993V24.9993L29.7365 27.3679M30.1993 34.0993H37.9993M34.0993 30.1993V37.9993M37.8953 26.6464C38.2388 23.9563 37.7323 21.2262 36.4469 18.8382C35.1615 16.4503 33.1615 14.5241 30.7269 13.3294C28.2923 12.1348 25.5451 11.7313 22.8698 12.1757C20.1946 12.6201 17.7252 13.89 15.8076 15.8076C13.89 17.7252 12.6201 20.1946 12.1757 22.8698C11.7313 25.5451 12.1348 28.2923 13.3294 30.7269C14.5241 33.1615 16.4503 35.1615 18.8382 36.4469C21.2262 37.7323 23.9563 38.2388 26.6464 37.8953",
    stroke: "#1290E0",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalShifts);
export default __webpack_public_path__ + "static/media/total-shifts.0b2605da828e986ed298a5fa25fd175f.svg";
export { ForwardRef as ReactComponent };